// Import controller interfaces
import {
    IDocumentController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api controller.
import ApiController from './ApiController';
// Import api models.
import {
    DocResponse,
    ErrorMessage,
    PossibleDocCategory,
} from '@app/models/api';

export default class ProductionDocumentController extends ApiController implements IDocumentController {

    private readonly controllerUrl: string = 'document';
    private readonly controllerV2Url: string = 'v2/document';

    public constructor() {
        super();
    }

    public async getPossibleDocCategories(): Promise<PossibleDocCategory[]> {
        let url: string = `${this.controllerUrl}/categories`;

        try {
            let response: Response = await super.makeGetCall(url);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'Could not get document categories.';
            }
            throw error;
        }
    }

    public async getPossibleDocCategoriesAdmin(): Promise<PossibleDocCategory[]> {
        let url: string = `${this.controllerUrl}/admin/categories`;

        try {
            let response: Response = await super.makeGetCall(url);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'Could not get document categories.';
            }
            throw error;
        }
    }

    public async getPolicyPackets(policyId: number, zipCode: string): Promise<DocResponse[]> {
        let url: string = `${this.controllerV2Url}/public/${policyId}/${zipCode}`;
        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'ERROR: could not get document.';
            }
            throw error;
        }
    }
};